import { FC, useState } from 'react';

import { ZazumeModal } from '@zazume/zzm-base';

import { InvoicesKeys } from '#/hooks/api/invoices/InvoicesKeys';
import { InvoiceHelper } from '#/models/helpers/invoice/InvoiceHelper';
import { Invoice } from '#/models/invoice/Invoice';

import { useGet } from '../../hooks/api/useGet';
import { API } from '../../lib/network/API';
import { Document } from '../../models';
import { AsyncComponent } from '../async/AsyncComponent';
import { DesktopNavigationButtons } from './DesktopNavigationButtons';
import { InvoiceDocumentModalContent } from './InvoiceDocumentModalContent';
import { RenderInvoiceDocumentTabContent } from './RenderInvoiceDocumentTabContent';

interface InvoiceDocumentModalProps {
  document: Document;
  close: () => void;
  onNextClick?: (id: string) => void;
  onPreviousClick?: (id: string) => void;
  hasNext?: boolean;
  hasPrevious?: boolean;
}

export const InvoiceDocumentModal: FC<InvoiceDocumentModalProps> = ({
  close,
  document,
  onNextClick,
  onPreviousClick,
  hasNext,
  hasPrevious
}) => {
  const { _id: documentId, filename } = document;
  const apiResult = useGet<Invoice>(InvoicesKeys.fromDocument(documentId), API.invoices.getFromDocumentId(documentId));
  const [modalTitle, setModalTitle] = useState<string>(filename);

  return (
    <DesktopNavigationButtons
      documentId={document._id}
      onNextClick={onNextClick}
      onPreviousClick={onPreviousClick}
      hasNext={hasNext}
      hasPrevious={hasPrevious}
    >
      <ZazumeModal title={modalTitle} onClose={close}>
        <AsyncComponent apiResult={apiResult}>
          {invoice => {
            const invoiceHelper = new InvoiceHelper(invoice);
            const hasCreditNote = invoiceHelper.hasCreditNote();
            const isCreditNote = invoiceHelper.isCreditNote();

            if (!isCreditNote && !hasCreditNote) {
              return (
                <RenderInvoiceDocumentTabContent
                  document={document}
                  close={close}
                  onNextClick={onNextClick}
                  onPreviousClick={onPreviousClick}
                  hasNext={hasNext}
                  hasPrevious={hasPrevious}
                />
              );
            }

            const linkedInvoiceId = invoiceHelper.getLinkedInvoiceId();

            return (
              <InvoiceDocumentModalContent
                close={close}
                document={document}
                linkedInvoiceId={linkedInvoiceId!}
                onTabChange={setModalTitle}
                onNextClick={onNextClick}
                onPreviousClick={onPreviousClick}
                hasNext={hasNext}
                hasPrevious={hasPrevious}
              />
            );
          }}
        </AsyncComponent>
      </ZazumeModal>
    </DesktopNavigationButtons>
  );
};
